import { render, staticRenderFns } from "./yuyue_1.vue?vue&type=template&id=b8af0876&scoped=true"
import script from "./yuyue_1.vue?vue&type=script&lang=js"
export * from "./yuyue_1.vue?vue&type=script&lang=js"
import style0 from "./yuyue_1.vue?vue&type=style&index=0&id=b8af0876&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8af0876",
  null
  
)

export default component.exports